import { apiClient } from './api'

export interface DeviceTypeData {
  device_type: string
  description?: string
  expected_interval_minutes?: number
  missed_transmissions?: number
  device_count: number
  parameter_count: number
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export interface DeviceTypeUpdateData {
  description?: string
  expected_interval_minutes?: number
  missed_transmissions?: number
  is_active?: boolean
}

export const deviceTypeService = {
  list: async (): Promise<DeviceTypeData[]> => {
    const { data } = await apiClient.get<DeviceTypeData[]>('/device-types')
    return data
  },

  get: async (deviceType: string): Promise<DeviceTypeData> => {
    const { data } = await apiClient.get<DeviceTypeData>(`/device-types/${deviceType}`)
    return data
  },

  update: async (deviceType: string, updateData: DeviceTypeUpdateData): Promise<DeviceTypeData> => {
    const { data } = await apiClient.put<DeviceTypeData>(`/device-types/${deviceType}`, updateData)
    return data
  }
}
